import { Home } from 'modules/Home' // 我的面板 01
import User from 'modules/User' // 登录注册
import System from 'modules/System' // Demo
import Modeling from 'modules/modeling'
import Demo  from "demo";

import ApplicationSetting from 'page/application'
import Mdm from 'page/mdm'
import Pos from 'page/pos'
import InterfacePage from 'page/interface'

let routers = [...User, ...Home, ...System, ...Demo, ...Modeling,...ApplicationSetting,...Mdm,...Pos,...InterfacePage]
export default routers



// WEBPACK FOOTER //
// ./src/modules.ts